import { createContext, useContext } from 'react';
import { createTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// Query fixa com os breakpoints padrão do MUI (o tema não os customiza): o
// AppThemeProvider usa a query antes de existir um tema no contexto.
const BELOW_XL = createTheme().breakpoints.down('xl');

export const DashboardCompactContext = createContext(false);

// Única assinatura da media query, feita pelo AppThemeProvider só na
// superfície dashboard; o resultado chega aos componentes pelo contexto.
export function useBelowXl() {
  return useMediaQuery(BELOW_XL, { noSsr: true });
}

// Dashboard compacto abaixo do breakpoint xl (1536px). Usado pelos componentes
// de layout do dashboard que dependem de medidas fora do tema (alturas,
// larguras, espaçamentos). Fora do dashboard é sempre false.
export default function useDashboardCompact() {
  return useContext(DashboardCompactContext);
}
